import { createElement } from 'react';
import "./menu-list-item.scss";
const MenuListItem = ({ title = '菜单名称', iconUrl = '', handleClick, }) => {
    return (createElement("div", { className: "menu-list__panel__item", onClick: handleClick },
        iconUrl ? createElement("div", { className: "menu-list__panel__item_icon" },
            createElement("img", { alt: "", src: iconUrl }))
            : null,
        createElement("div", { className: "menu-list__panel__item_title" }, title),
        createElement("div", { className: "menu-list__panel__item_right" },
            createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
                createElement("path", { fill: "currentColor", d: "M22 16L12 26l-1.4-1.4l8.6-8.6l-8.6-8.6L12 6z" })))));
};
MenuListItem.displayName = 'MenuListItem';
export default MenuListItem;
